export const GET_STATS = 'GET_STATS'
export const GET_STATS_FULFILLED = 'GET_STATS_FULFILLED'
export const GET_STATS_REJECTED = 'GET_STATS_REJECTED'
/**
 * Gets stats URL from stats service.
 * See: https://promoboxx.postman.co/collections/5460075-4f432dc3-5664-42f2-968f-6af89769a628?version=latest&workspace=d5e9e9bc-a697-4e1d-8dbc-56461f7af430#630cc7ae-203d-4005-8ca5-623a472cf696
 * @param {{ 
 *  statsType: string,
 *  params: {{
 *    brandIds: Array<string>,
 *    retailerIds: Array<string>,
 *    filterIds: Array<string>,
 *  }},
 * }} payload
 */
export const getStats = (payload) => ({ type: GET_STATS, payload })
